import React from 'react';
import { Form, InputNumber, Modal } from 'antd';

/**
 * Modal de edición de un registro de Pokedex.
 *
 * Edita únicamente el N° de Pokedex. El pokemon asociado y la
 * consistencia se mantienen intactos (no se envía `poke_id` al backend,
 * por lo que el registro conserva su pokemon original).
 *
 * Props:
 *  - open: bool
 *  - onCancel: () => void
 *  - record: la fila que se está editando (debe incluir id, numero_pokedex)
 *  - onSubmit: (values) => void — recibe { id, numero_pokedex }
 */
export const PokedexEditForm = ({ open, onCancel, record, onSubmit }) => {
    const [form] = Form.useForm();

    // Sincronizar el form con la fila cada vez que cambia el record.
    // Usamos requestAnimationFrame para que AntD termine de montar el
    // Form interno antes del setFieldsValue (evita warnings de "Instance
    // created by useForm is not connected to any Form element").
    React.useEffect(() => {
        if (open && record) {
            const id = requestAnimationFrame(() => {
                form.setFieldsValue({ numero_pokedex: record.numero_pokedex });
            });
            return () => cancelAnimationFrame(id);
        } else if (!open) {
            form.resetFields();
        }
    }, [open, record, form]);

    const handleOk = () => {
        form.validateFields()
            .then((values) => {
                onSubmit({
                    id: record?.id,
                    numero_pokedex: values.numero_pokedex,
                });
            })
            .catch(() => {
                // Validación ya muestra los errores en cada Form.Item
            });
    };

    return (
        <Modal
            title="Editar Registro Pokedex"
            open={open}
            onOk={handleOk}
            onCancel={onCancel}
            okText="Guardar"
            cancelText="Cancelar"
            destroyOnClose
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    name="numero_pokedex"
                    label="Numero Pokedex"
                    rules={[{ required: true, message: 'El numero de pokedex es requerido' }]}
                >
                    <InputNumber style={{ width: '100%' }} />
                </Form.Item>
            </Form>
        </Modal>
    );
};
